import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {DIDOMI_NOTICE} from "../../../consts";
import {LocalStorageUtils} from "../../../../infrastructure/utils/local-storage.utils";
import {PrivacySettingsNoticeDisplayHandler} from "./privacy-settings.notice-display.handler";

export class PrivacySettingsVendorsDisplayHandler extends PrivacySettingsNoticeDisplayHandler {
  analyticsService: AnalyticsService;
  localStorageUtils: LocalStorageUtils;
  type = DIDOMI_NOTICE.ACTION_TYPES.vendorsDisplay;

  static injectables = [AnalyticsService, LocalStorageUtils];

  get noticeEventType() {
    return DIDOMI_NOTICE.EVENT_TYPES.vendors
  }

  get noticeStorageKey() {
    return DIDOMI_NOTICE.KEYS.vendors
  }
}
